export default __webpack_public_path__ + "static/media/headshot.6ea1d541.png";